import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import ProductCallout from '~/shared/components/ProductCallout';

import { useProductCalloutOverlay } from '../../hooks/useProductCalloutOverlay';

const CalloutOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.colors.semanticColors.lightShadow2};
  pointer-events: none;
`;

const CalloutOverlayText = styled(ProductCallout)`
  ${({ theme }) => theme.gridStyles.productCalloutOverlayStyle}
`;

const ProductCardCalloutOverlay = ({ product }) => {
  const { shouldShowCalloutOverlay, callout } = useProductCalloutOverlay({
    product,
  });

  if (!shouldShowCalloutOverlay) {
    return null;
  }

  return (
    <CalloutOverlay>
      <CalloutOverlayText type={callout?.type} value={callout?.value} />
    </CalloutOverlay>
  );
};

ProductCardCalloutOverlay.propTypes = {
  product: PropTypes.shape({
    dateExpected: PropTypes.string,
    tagIdList: PropTypes.arrayOf(PropTypes.number),
    membershipBrandId: PropTypes.number,
    waitListAllowed: PropTypes.bool,
    skus: PropTypes.arrayOf(
      PropTypes.shape({
        availableQuantity: PropTypes.number,
        isPreorder: PropTypes.bool,
      })
    ),
    availableQuantity: PropTypes.number,
    availableQuantityMaster: PropTypes.number,
    productIdObjectList: PropTypes.arrayOf(
      PropTypes.shape({
        availableQuantity: PropTypes.number,
        availableQuantityPreorder: PropTypes.number,
      })
    ),
  }),
};

export default ProductCardCalloutOverlay;
